<!--
  Ficha de una tienda del comercio — PÁGINA con ruta propia, a todo el ancho.

  🔴 REDISEÑO 2026-09-20 — esta pantalla se había quedado afuera del reparto y
  se notaba al entrar: se sale de Tiendas, que ya es plana, y se caía en dos
  tarjetas grandes con su subtítulo. *«Demasiada caja, demasiado contenido, la
  vista se pierde»*.

  Lo que salió, y por qué:
    · las dos `.kb-card` —Identificación y Cajas— envolvían campos de LECTURA y
      una tabla: la caja no se ganaba nada, sólo dibujaba borde y sombra. Ahora
      son `.kb-seccion` con su regla, y la tabla va en `.kb-tabla-plana`;
    · los dos `kb-card-desc`. El de Identificación decía algo que el título no
      dice —de esta tienda sale a qué comercio pertenece cada venta— y bajó
      pegado al Código, que es el dato del que habla. El de Cajas repetía el
      título; lo único suyo —que el usuario que opera la caja se crea aparte—
      quedó al pie de la sección, junto a la nota de por qué no se borran;
    · «acá» → «aquí»: era el último que quedaba en las siete pantallas.

  ⚠️ La miga de pan y la vuelta apuntan a `…/tiendas`, que es la pantalla de
  donde se viene. No al `?tab=tiendas` de la ficha, que ya no lee nadie.
-->
<div class="kb-page">

  <!-- ══ Migas — de dónde se viene ════════════════════════════════════════════ -->
  <nav class="kb-migas" aria-label="Ubicación">
    <a class="kb-miga" [routerLink]="['/console/merchants']">Comercios</a>
    <span class="kb-miga-sep" aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
    <a class="kb-miga" [routerLink]="['/console/merchants', codigo]">{{ comercio?.name || codigo }}</a>
    <span class="kb-miga-sep" aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
    <a class="kb-miga" [routerLink]="['/console/merchants', codigo, 'tiendas']">Tiendas</a>
    <span class="kb-miga-sep" aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
    <span class="kb-miga-actual">{{ tienda?.name || tienda?.short_name || codigoTienda }}</span>
  </nav>

  <!-- ══ Cargando ═════════════════════════════════════════════════════════════ -->
  <!-- El esqueleto conserva la FORMA de lo que viene: el encabezado, un bloque de
       pares y la tabla de cajas. Con otra silueta, la pantalla salta al cargar. -->
  <div *ngIf="cargando" class="space-y-8" aria-live="polite" aria-busy="true">
    <div class="kb-skeleton h-9 w-1/3"></div>
    <div class="space-y-4">
      <div class="kb-skeleton h-3 w-28"></div>
      <div class="kb-skeleton h-5 w-full max-w-lg" *ngFor="let s of [1,2,3]"></div>
    </div>
    <div class="kb-skeleton h-40 w-full"></div>
  </div>

  <!-- ══ No existe ════════════════════════════════════════════════════════════ -->
  <div class="kb-empty" *ngIf="!cargando && noEncontrada">
    <span class="kb-empty-icono"><i class="fas fa-store-slash" aria-hidden="true"></i></span>
    <p class="kb-empty-titulo">No encontramos la tienda «{{ codigoTienda }}»</p>
    <p class="kb-empty-texto">
      Puede que no sea de este comercio, o que el código esté mal escrito.
    </p>
    <button type="button" class="kb-btn kb-btn-outline mt-4" (click)="volverATiendas()">
      <i class="fas fa-arrow-left" aria-hidden="true"></i>Volver a tiendas
    </button>
  </div>

  <ng-container *ngIf="!cargando && tienda">

    <!-- ══ Encabezado ═════════════════════════════════════════════════════════ -->
    <div class="kb-ficha">
      <div class="min-w-0">
        <h1 class="kb-ficha-titulo truncate">{{ tienda.name || tienda.short_name || tienda.code }}</h1>
        <p class="kb-ficha-meta">
          <span class="font-mono">{{ tienda.code }}</span>
          <span aria-hidden="true">·</span>
          <span class="truncate">Punto de venta de {{ comercio?.name || codigo }}</span>
        </p>
        <div class="mt-3 flex flex-wrap items-center gap-2">
          <span class="kb-badge kb-badge-exito" *ngIf="tienda.status !== false">
            <i class="fas fa-check-circle" aria-hidden="true"></i>Activa
          </span>
          <span class="kb-badge kb-badge-neutro" *ngIf="tienda.status === false">
            <i class="fas fa-ban" aria-hidden="true"></i>Inhabilitada
          </span>
          <span class="kb-badge kb-badge-contorno" *ngIf="!cargandoCajas && !errorCajas">
            <i class="fas fa-cash-register" aria-hidden="true"></i>
            <span class="tabular-nums">{{ cajas.length }}</span>
            {{ cajas.length === 1 ? 'caja' : 'cajas' }}
          </span>
        </div>
      </div>

      <div class="flex flex-wrap items-center gap-2 sm:shrink-0">
        <button type="button" class="kb-btn kb-btn-outline" (click)="volverATiendas()">
          <i class="fas fa-arrow-left" aria-hidden="true"></i>Volver a tiendas
        </button>
      </div>
    </div>

    <div class="space-y-8">

      <!-- ══════════════ IDENTIFICACIÓN ═══════════════════════════════════════ -->
      <section class="kb-tarjeta">
        <div class="kb-tarjeta-cab">
          <h2 class="text-base font-semibold leading-none">Identificación</h2>
        </div>
        <div class="kb-tarjeta-cuerpo">

        <dl class="kb-datos">
          <dt class="kb-dato-et">Código</dt>
          <dd class="m-0">
            <span class="kb-dato-val font-mono">{{ tienda.code }}</span>
            <!-- Lo que decía el subtítulo, pegado al dato del que hablaba. -->
            <span class="kb-dato-nota ml-2">
              de aquí sale a qué comercio pertenece cada venta que se origina en esta tienda
            </span>
          </dd>

          <dt class="kb-dato-et">Nombre</dt>
          <dd class="m-0">
            <span class="kb-dato-val" *ngIf="tienda.name">{{ tienda.name }}</span>
            <span class="kb-dato-val italic text-muted-foreground" *ngIf="!tienda.name">Sin registrar</span>
          </dd>

          <dt class="kb-dato-et">Nombre corto</dt>
          <dd class="m-0">
            <span class="kb-dato-val" *ngIf="tienda.short_name">{{ tienda.short_name }}</span>
            <span class="kb-dato-val italic text-muted-foreground" *ngIf="!tienda.short_name">Sin registrar</span>
          </dd>

          <dt class="kb-dato-et">Ciudad</dt>
          <dd class="m-0">
            <span class="kb-dato-val" *ngIf="tienda.city">{{ tienda.city }}</span>
            <span class="kb-dato-val italic text-muted-foreground" *ngIf="!tienda.city">Sin registrar</span>
          </dd>

          <dt class="kb-dato-et">Dirección</dt>
          <dd class="m-0">
            <span class="kb-dato-val" *ngIf="tienda.address">{{ tienda.address }}</span>
            <span class="kb-dato-val italic text-muted-foreground" *ngIf="!tienda.address">Sin registrar</span>
          </dd>
        </dl>
        </div>
      </section>

      <!-- ══════════════ CAJAS ════════════════════════════════════════════════ -->
      <section class="kb-tarjeta">
        <div class="kb-tarjeta-cab">
          <h2 class="text-base font-semibold leading-none">Cajas</h2>
          <div class="kb-tarjeta-accion flex flex-wrap items-center gap-2">
          <button type="button" class="kb-btn kb-btn-primary kb-btn-sm shrink-0"
                  *ngIf="!formCaja && tienda.status !== false" (click)="abrirFormCaja()">
            <i class="fas fa-plus" aria-hidden="true"></i>Agregar una caja
          </button>
          </div>
        </div>
        <div class="kb-tarjeta-cuerpo">

        <p class="kb-hint" *ngIf="tienda.status === false">
          La tienda está inhabilitada: no se le pueden agregar cajas hasta que se habilite.
        </p>

        <!-- ── El alta, en la misma página ────────────────────────────────────
             La caja de este bloque sí se gana su existencia: separa lo que se
             ESCRIBE de lo que se lee. La regla es para los campos de lectura. -->
        <div class="rounded-lg border border-border bg-muted/30 p-4" *ngIf="formCaja">
          <p class="kb-section-title mb-3">Nueva caja</p>

          <div class="grid gap-3 sm:grid-cols-2">
            <div>
              <label class="kb-label" for="cajaNum">Número de caja <span class="text-destructive">*</span></label>
              <input id="cajaNum" type="number" min="1" step="1" class="kb-input tabular-nums"
                     [(ngModel)]="formCaja.cash_register_number" placeholder="1" autocomplete="off">
              <p class="kb-error" *ngIf="numeroRepetido">
                Esta tienda ya tiene la caja {{ numeroCajaNuevo }}. Elige otro número.
              </p>
            </div>
            <div>
              <label class="kb-label" for="cajaAfil">
                Número de afiliación <span class="text-destructive">*</span>
              </label>
              <input id="cajaAfil" type="text" class="kb-input font-mono"
                     [(ngModel)]="formCaja.afiliation_number" placeholder="0001234567"
                     autocomplete="off">
              <!-- 📍 Es el dato que más se pregunta: va explicado, no supuesto. -->
              <p class="kb-hint">
                Es el número con el que el banco identifica este punto de venta. Sin él, el cobro
                no se puede conciliar con lo que informa el banco.
              </p>
            </div>
            <div>
              <label class="kb-label" for="cajaTipo">Tipo</label>
              <div class="kb-select-envoltorio">
                <select id="cajaTipo" class="kb-select" [(ngModel)]="formCaja.type">
                  <option value="NORMAL">Normal — la atiende un cajero</option>
                  <option value="AUTOPAGO">Autopago — el cliente se cobra solo</option>
                </select>
                <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
              </div>
            </div>
            <div>
              <label class="kb-label" for="cajaDesc">Descripción</label>
              <input id="cajaDesc" type="text" class="kb-input"
                     [(ngModel)]="formCaja.description" placeholder="Caja de la entrada"
                     autocomplete="off">
              <p class="kb-hint">Opcional. Para reconocerla dentro del local.</p>
            </div>
          </div>

          <div class="kb-acciones-grupo mt-4">
            <button type="button" class="kb-btn kb-btn-primary kb-btn-sm"
                    [disabled]="!formCajaValido || guardandoCaja" (click)="crearCaja()">
              <i class="fas fa-check" aria-hidden="true"></i>
              {{ guardandoCaja ? 'Creando…' : 'Crear la caja' }}
            </button>
            <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm"
                    [disabled]="guardandoCaja" (click)="cerrarFormCaja()">Cancelar</button>
          </div>
        </div>

        <div class="kb-skeleton h-24" *ngIf="cargandoCajas"></div>

        <!-- ⚠️ Un error del servidor no se muestra como «no tiene cajas». -->
        <div class="kb-aviso kb-aviso-peligro" *ngIf="!cargandoCajas && errorCajas">
          <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i>
          <div>
            <p class="kb-aviso-titulo">No se pudieron traer las cajas</p>
            <p>{{ errorCajas }}</p>
            <button type="button" class="kb-btn kb-btn-outline kb-btn-sm mt-3" (click)="cargarCajas()">
              <i class="fas fa-redo" aria-hidden="true"></i>Volver a consultar las cajas
            </button>
          </div>
        </div>

        <div class="kb-empty" *ngIf="!cargandoCajas && !errorCajas && !cajas.length">
          <span class="kb-empty-icono"><i class="fas fa-cash-register" aria-hidden="true"></i></span>
          <p class="kb-empty-titulo">Esta tienda todavía no tiene cajas</p>
          <p class="kb-empty-texto">
            Sin una caja, no hay dónde estampar el cobro que se hace en este local.
          </p>
        </div>

        <!-- La tabla, a la vista: sin la tarjeta alrededor. -->
        <div class="kb-tabla-plana" *ngIf="!cargandoCajas && cajas.length">
          <table class="kb-table">
            <thead class="kb-thead">
              <tr>
                <th class="kb-th">Caja</th>
                <th class="kb-th">Afiliación</th>
                <th class="kb-th">Tipo</th>
                <th class="kb-th">Descripción</th>
                <th class="kb-th">Estado</th>
                <th class="kb-th-acciones">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr class="kb-tr" *ngFor="let c of cajas"
                  [ngClass]="{'kb-tr-atenuada': c.status === false}">
                <td class="kb-td tabular-nums">{{ c.cash_register_number }}</td>
                <td class="kb-td kb-td-mono tabular-nums">{{ c.afiliation_number || '—' }}</td>
                <td class="kb-td">{{ tipoEnPalabras(c.type) }}</td>
                <td class="kb-td kb-td-sub">{{ c.description || '—' }}</td>
                <td class="kb-td">
                  <span class="kb-badge" [ngClass]="c.status !== false ? 'kb-badge-exito' : 'kb-badge-neutro'">
                    {{ c.status !== false ? 'Activa' : 'Inactiva' }}
                  </span>
                </td>
                <td class="kb-td-acciones">
                  <div class="kb-acciones-grupo">
                    <button type="button" class="kb-btn kb-btn-danger kb-btn-icon"
                            *ngIf="c.status !== false"
                            aria-label="Desactivar esta caja"
                            title="Desactivar esta caja" (click)="desactivarCaja(c)">
                      <i class="fas fa-power-off" aria-hidden="true"></i>
                    </button>
                    <span class="kb-hint" *ngIf="c.status === false">Desactivada</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- El pie de la sección: lo que hay que saber de una caja y no se ve en
             la tabla. La segunda oración es lo que se salvó del subtítulo. -->
        <p class="kb-hint">
          Las cajas se desactivan, no se borran: una caja que ya cobró está estampada en ventas,
          y borrarla deja esas ventas apuntando a una caja que no existe. El usuario que opera la
          caja se crea aparte, en Usuarios del comercio: lo que viaja estampado en la venta es
          esta caja, no el nombre de quien la usó.
        </p>
        </div>
      </section>

    </div>

  </ng-container>
</div>
